<template>
    <div id="devices" class="section">
        <h1 class="header">{{ $t("devices.header") }}<span class="header-dot">.</span></h1>
        <h3 class="introduction">{{ $t("devices.introduction") }}</h3>
        <div class="header-separator"></div>
        <div class="content">

            <div class="alternating-display">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX A35</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-A35.line-1") }}</p>
                        <br>
                        <p>{{ $t("devices.PAX-A35.line-2") }}</p>
                        <ul>
                            <li>{{ $t("devices.PAX-A35.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-A35.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-A35.list.item-3") }}</li>
                        </ul>
                        <br>
                        <p>{{ $t("devices.PAX-A35.line-3") }}</p>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxA35.webp" alt="">
                    <p class="inspect-text top-left-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">A35</span>
                    </p>
                </div>
            </div>

            <div class="alternating-display alter">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX A920Pro</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-A920Pro.line-1") }}</p>
                        <br>
                        <ul>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-3") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-4") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-5") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-6") }}</li>
                            <li>{{ $t("devices.PAX-A920Pro.list.item-7") }}</li>
                            <br>
                        </ul>
                        <p>{{ $t("devices.PAX-A920Pro.line-2") }}</p>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxA920Pro.png" alt="">
                    <p class="inspect-text top-right-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">A920Pro</span>
                    </p>
                </div>
            </div>

            <div class="alternating-display">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX A77</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-A77.line-1") }}</p>
                        <br>
                        <ul>
                            <li>{{ $t("devices.PAX-A77.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-A77.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-A77.list.item-3") }}</li>
                            <li>{{ $t("devices.PAX-A77.list.item-4") }}</li>
                        </ul>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxA77.webp" alt="">
                    <p class="inspect-text top-left-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">A77</span>
                    </p>
                </div>
            </div>

            <div class="alternating-display alter">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX A80</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-A80.line-1") }}</p>
                        <br>
                        <ul>
                            <li>{{ $t("devices.PAX-A80.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-A80.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-A80.list.item-3") }}</li>
                        </ul>
                        <br>
                        <p>{{ $t("devices.PAX-A80.line-2") }}</p>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxA80.png" alt="">
                    <p class="inspect-text top-right-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">A80</span>
                    </p>
                </div>
            </div>

            <div class="alternating-display">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX A960</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-A960.line-1") }}</p>
                        <br>
                        <ul>
                            <li>{{ $t("devices.PAX-A960.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-A960.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-A960.list.item-3") }}</li>
                            <li>{{ $t("devices.PAX-A960.list.item-4") }}</li>
                        </ul>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxA960.png" alt="">
                    <p class="inspect-text top-left-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">A960</span>
                    </p>
                </div>
            </div>

            <div class="alternating-display alter">
                <div class="flavour-text">
                    <h1 class="flavour-header">PAX IM25</h1>
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("devices.PAX-IM25.line-1") }}</p>
                        <br>
                        <ul>
                            <li>{{ $t("devices.PAX-IM25.list.item-1") }}</li>
                            <li>{{ $t("devices.PAX-IM25.list.item-2") }}</li>
                            <li>{{ $t("devices.PAX-IM25.list.item-3") }}</li>
                            <li>{{ $t("devices.PAX-IM25.list.item-4") }}</li>
                            <li>{{ $t("devices.PAX-IM25.list.item-5") }}</li>
                        </ul>
                        <br>
                        <p>{{ $t("devices.PAX-IM25.line-2") }}</p>
                    </div>
                </div>
                <div class="displayed-item">
                    <div class="octagon"></div>
                    <img class="growing-image" src="../../../assets/images/devices/paxIM25.png" alt="">
                    <p class="inspect-text top-right-diagonal">
                        <span class="model-name">PAX</span>
                        <br>
                        <span class="model-number">IM25</span>
                    </p>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
    export default {

    }
</script>